__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@goodt/editor";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@codemirror/lang-css-6.3", "6.3.1", () => (Promise.all([__webpack_require__.e(3704), __webpack_require__.e(2264), __webpack_require__.e(5817), __webpack_require__.e(7061)]).then(() => (() => (__webpack_require__(57061))))));
			register("@codemirror/lang-sql-6.10", "6.10.0", () => (Promise.all([__webpack_require__.e(3704), __webpack_require__.e(2264), __webpack_require__.e(5817), __webpack_require__.e(1663)]).then(() => (() => (__webpack_require__(31663))))));
			register("@goodt-common/api", "0", () => (() => (__webpack_require__(5121))), 1);
			register("@goodt-common/application", "0", () => (() => (__webpack_require__(8784))), 1);
			register("@goodt-common/auth", "0", () => (() => (__webpack_require__(94403))), 1);
			register("@goodt-common/cache", "0", () => (() => (__webpack_require__(39916))), 1);
			register("@goodt-common/data", "0", () => (() => (__webpack_require__(58321))), 1);
			register("@goodt-common/devtools", "0", () => (() => (__webpack_require__(27829))), 1);
			register("@goodt-common/domain", "0", () => (() => (__webpack_require__(24677))), 1);
			register("@goodt-common/dremio-panels", "0", () => (() => (__webpack_require__(15053))), 1);
			register("@goodt-common/dremio", "0", () => (() => (__webpack_require__(19529))), 1);
			register("@goodt-common/error-service", "0", () => (() => (__webpack_require__(24664))), 1);
			register("@goodt-common/errors", "0", () => (() => (__webpack_require__(71511))), 1);
			register("@goodt-common/form", "0", () => (() => (__webpack_require__(97434))), 1);
			register("@goodt-common/graphql", "0", () => (() => (__webpack_require__(20000))), 1);
			register("@goodt-common/infra", "0", () => (() => (__webpack_require__(76773))), 1);
			register("@goodt-common/layers", "0", () => (() => (__webpack_require__(90306))), 1);
			register("@goodt-common/mixins", "0", () => (() => (__webpack_require__(11961))), 1);
			register("@goodt-common/net", "0", () => (() => (__webpack_require__(43128))), 1);
			register("@goodt-common/plugins", "0", () => (() => (__webpack_require__(69308))), 1);
			register("@goodt-common/service-container", "0", () => (() => (__webpack_require__(54120))), 1);
			register("@goodt-common/service-provider", "0", () => (() => (__webpack_require__(49602))), 1);
			register("@goodt-common/services", "0", () => (() => (__webpack_require__(93946))), 1);
			register("@goodt-common/shared", "0", () => (() => (__webpack_require__(90275))), 1);
			register("@goodt-common/utils-number", "0", () => (() => (__webpack_require__(10812))), 1);
			register("@goodt-common/utils", "0", () => (() => (__webpack_require__(93593))), 1);
			register("@goodt-wcore/compat", "0", () => (() => (__webpack_require__(32706))), 1);
			register("@goodt-wcore/components", "0", () => (() => (__webpack_require__(54440))), 1);
			register("@goodt-wcore/core", "0", () => (() => (__webpack_require__(3453))), 1);
			register("@goodt-wcore/elem", "0", () => (() => (__webpack_require__(32993))), 1);
			register("@goodt-wcore/errors", "0", () => (() => (__webpack_require__(39910))), 1);
			register("@goodt-wcore/managers", "0", () => (() => (__webpack_require__(33818))), 1);
			register("@goodt-wcore/panel-ui", "0", () => (() => (__webpack_require__(97703))), 1);
			register("@goodt-wcore/panel", "0", () => (() => (__webpack_require__(65282))), 1);
			register("@goodt-wcore/panels", "0", () => (() => (__webpack_require__(461))), 1);
			register("@goodt-wcore/render", "0", () => (() => (__webpack_require__(10321))), 1);
			register("@goodt-wcore/utils", "0", () => (() => (__webpack_require__(33343))), 1);
			register("@goodt/editor-migration-1.0", "1.0.14", () => (Promise.all([__webpack_require__.e(2619), __webpack_require__.e(9023)]).then(() => (() => (__webpack_require__(49023))))));
			register("dayjs", "0", () => (() => (__webpack_require__(34419))), 1);
			register("goodt-wcore", "0", () => (() => (__webpack_require__(52649))), 1);
			register("goodteditor-ui", "0", () => (() => (__webpack_require__(10103))), 1);
			register("jsonschema-1.5", "1.5.0", () => (() => (__webpack_require__(17194))));
			register("opentype.js-1.3", "1.3.4", () => (Promise.all([__webpack_require__.e(478), __webpack_require__.e(6782)]).then(() => (() => (__webpack_require__(95163))))));
			register("socket.io-client-4.8", "4.8.4", () => (Promise.all([__webpack_require__.e(2917), __webpack_require__.e(2768), __webpack_require__.e(7320), __webpack_require__.e(8141), __webpack_require__.e(9914)]).then(() => (() => (__webpack_require__(60098))))));
			register("vue", "0", () => (() => (__webpack_require__(51777))), 1);
			register("vuedraggable", "0", () => (() => (__webpack_require__(9026))), 1);
			register("woff2-encoder-2.0", "2.0.0", () => (__webpack_require__.e(8962).then(() => (() => (__webpack_require__(81530))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};